export default {
  topup_refill: 'Top up my balance',
  topup_topup: 'Top up',
  topup_balance: 'Your balance is %{amount} %{asset}',
  topup_percent_fee: 'percent fee',
  topup_fixed_fee: 'fixed fee',
  topup_approve: 'Fulfill',
  topup_reject: 'Reject',
  topup_withdraw: 'Choose payment option',
  topup_withdrawal: 'Withdrawal',
  topup_details: 'Withdrawal details',
  topup_pending: 'Pending',
  topup_created: 'Created',
  topup_approved: 'Approved',
  topup_cancelled: 'Cancelled',
  topup_rejected: 'Rejected',
  topup_permanently_rejected: 'Rejected',
  topup_confirm: 'Top up confirmation',
  topup_how_much: 'Minimum amount is %{value} %{asset}',
  topup_minimal: 'Please note, in addition to the amount of top up transaction network fees can be charged',
  topup_crypto_minimal: 'Please note that when replenishing the balance you may be charged a network commission.',
  topup_failed_get_address: 'Failed to get address.',
  topup_network_fee: 'Please note that network fee will be separately charged from amount of top up transaction',
  topup_ex_address: 'Top up external address',
  topup_to: 'Top up to:',
  topup_cashbox: 'Cashbox',
  topup_ucash: 'UPLATA (ID %{taid})',
  topup_uplata_insha: 'Visa Insha (%{uplataInsha})',
  topup_xpay: '%{name} (%{mask_pan})',
  topup_external: 'Address %{asset}',
  topup_add_xpay_card: 'Add payment card',
  topup_nothere: 'Top up is not allowed',
  topup_success: 'Top up request successfully created',
  topup_request: 'Top up request',
  topup_error_is_trying_to_send_to_yourself: 'Sender can\'t be a recipient! Make sure the address is correct',
  topup_error_invalid_address: 'Invalid wallet address',
  topup_error_insufficient_funds: 'Insufficient funds',
  topup_error_minimum_amount: 'The minimum amount is %{value} %{asset}',
  topup_error_maximum_amount: 'The minimum amount is %{value} %{asset}',
  topup_no_withdrawals: 'No top up requests',
  topup_no_withdrawals_desc: 'Here will be the list of top up requests',
  topup_no_assets: 'No top up assets in your wallet',
  topup_no_assets_exp: 'This feature will be available once you have any top up asset',
  topup_amount_round: 'Top up amount will be round down to %{amount} %{asset}',
  topup_reject_reason_prompt: 'Enter the reject reason',
  topup_reject_reason_warn: 'Reject reason must not be empty',
  topup_request_approved: 'Top up request fulfilled succesfully',
  topup_request_rejected: 'Top up request is rejected',
  topup_creation_date: 'Creation date',
  topup_updating_date: 'Updating date',
  topup_list_tooltip: 'Use mouse double click to open the approval form',
  topup_otp_code_confirm: 'OTP code confirmation',
  topup_secure_msg_status_1: 'Accepted for processing',
  topup_secure_msg_status_2: '3DS Card Check',
  topup_secure_msg_status_3: 'OTP pending',
  topup_secure_msg_status_4: 'Queue operation',
  topup_secure_msg_status_5: 'Operation in processing',
  topup_secure_msg_status_6: 'Invoice created, awaiting payment',
  topup_secure_msg_status_7: 'Commission operation calculated',
  topup_secure_msg_status_10: 'Operation completed',
  topup_secure_msg_status_20: '3DS Verification Error',
  topup_secure_msg_status_21: 'Operation error'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/topup_view.js